import React from 'react';
import { View } from 'react-native';
import type { AttendanceStatus } from '@hrms/shared';
import { humanize } from '../../../lib/date';
import { Text, type Colors } from '../../../ui';

export const attColor = (c: Colors, s: AttendanceStatus): string =>
  ({ present: c.success, absent: c.danger, half_day: c.warning, weekly_off: c.faint, holiday: c.info, leave: c.primary, half_leave: c.primary, on_duty: c.success })[s];

export const attBg = (c: Colors, s: AttendanceStatus): string | undefined =>
  ({ absent: c.dangerSoft, holiday: c.infoSoft, leave: c.primarySoft, half_leave: c.primarySoft, weekly_off: c.surface2 } as Partial<Record<AttendanceStatus, string>>)[s];

const ALL: AttendanceStatus[] = ['present', 'absent', 'half_day', 'weekly_off', 'holiday', 'leave', 'half_leave', 'on_duty'];

export function AttendanceLegend({ colors }: { colors: Colors }) {
  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
      {ALL.map((s) => (
        <View key={s} style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
          <View style={{ width: 10, height: 10, borderRadius: 3, backgroundColor: attColor(colors, s) }} />
          <Text size={12}>{humanize(s)}</Text>
        </View>
      ))}
    </View>
  );
}
